var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHolders({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9 4.5C15.9 6.57107 14.154 8.25 12 8.25C9.84614 8.25 8.10005 6.57107 8.10005 4.5C8.10005 2.42893 9.84614 0.75 12 0.75C14.154 0.75 15.9 2.42893 15.9 4.5Z",
    fill: "#CCCDD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4 7C22.4 8.38071 21.236 9.5 19.8001 9.5C18.3641 9.5 17.2001 8.38071 17.2001 7C17.2001 5.61929 18.3641 4.5 19.8001 4.5C21.236 4.5 22.4 5.61929 22.4 7Z",
    fill: "#CCCDD4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2001 15.75C17.2001 12.9886 14.8719 10.75 12 10.75C9.12817 10.75 6.80005 12.9886 6.80005 15.75V19.5H17.2001V15.75Z",
    fill: "#CCCDD4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80005 7C6.80005 8.38071 5.63599 9.5 4.20005 9.5C2.76411 9.5 1.60005 8.38071 1.60005 7C1.60005 5.61929 2.76411 4.5 4.20005 4.5C5.63599 4.5 6.80005 5.61929 6.80005 7Z",
    fill: "#CCCDD4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8001 19.5V15.75C19.8001 14.4323 19.4466 13.194 18.826 12.1179C19.1374 12.0409 19.4637 12 19.8001 12C21.954 12 23.7001 13.6789 23.7001 15.75V19.5H19.8001Z",
    fill: "#CCCDD4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17409 12.1179C4.55345 13.194 4.20005 14.4323 4.20005 15.75V19.5H0.300049V15.75C0.300049 13.6789 2.04614 12 4.20005 12C4.53637 12 4.86275 12.0409 5.17409 12.1179Z",
    fill: "#CCCDD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolders);
export default __webpack_public_path__ + "static/media/holders.bafdf996.svg";
export { ForwardRef as ReactComponent };